import { Document } from '@contentful/rich-text-types';

import Footer, { IFooterProps } from 'components/landing-pages-v2/shared/footer/Footer';

import { ISiteFooter } from 'declarations/contentful';

interface SharedContentfulFooterProps {
  footer?: ISiteFooter | null;
  extraLegalText?: Document;
  showCustomerTestimonialLegal?: boolean;
  showEligibilityLegal?: boolean;
  showPromotionLegal?: boolean;
  showThePdpCopyrightLegal?: boolean;
}

const DEFAULT_APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/opendoor-buy-sell-homes/id1144498656';
const DEFAULT_GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en_US';
const DEFAULT_HELP_CENTER_LINK = 'https://help.opendoor.com';

const SharedContentfulFooter = ({
  footer,
  extraLegalText,
  showCustomerTestimonialLegal,
  showEligibilityLegal,
  showPromotionLegal,
  showThePdpCopyrightLegal,
}: SharedContentfulFooterProps) => {
  if (footer) {
    return (
      <Footer
        footerTitle={footer.fields.footerTitle}
        footerNav={footer.fields.footerNav}
        sellInYourMarket={footer.fields.sellInYourMarket as IFooterProps['sellInYourMarket']}
        googlePlaystoreLink={footer.fields.googlePlaystoreLink || DEFAULT_GOOGLE_PLAY_LINK}
        appleStoreLink={footer.fields.appleStoreLink || DEFAULT_APPLE_STORE_LINK}
        helpCenterLink={footer.fields.helpCenterLink || DEFAULT_HELP_CENTER_LINK}
        backgroundColor={footer.fields.backgroundColor}
        extraLegalText={extraLegalText}
        showCustomerTestimonialLegal={showCustomerTestimonialLegal}
        showEligibilityLegal={showEligibilityLegal}
        showPromotionLegal={showPromotionLegal}
        showThePdpCopyrightLegal={showThePdpCopyrightLegal}
        locale={footer.sys.locale}
      />
    );
  }

  return (
    <Footer
      googlePlaystoreLink={DEFAULT_GOOGLE_PLAY_LINK}
      appleStoreLink={DEFAULT_APPLE_STORE_LINK}
      helpCenterLink={DEFAULT_HELP_CENTER_LINK}
      backgroundColor="Grey"
    />
  );
};

export default SharedContentfulFooter;
